import { render, staticRenderFns } from "./Microscopia.vue?vue&type=template&id=29fe1b3c&scoped=true"
import script from "./Microscopia.vue?vue&type=script&lang=js"
export * from "./Microscopia.vue?vue&type=script&lang=js"
import style0 from "./Microscopia.vue?vue&type=style&index=0&id=29fe1b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe1b3c",
  null
  
)

export default component.exports